export default __webpack_public_path__ + "static/media/medal-5.a9a10bfa.svg";